import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Row, Card, Descriptions, message, Typography, Skeleton } from "antd";

import { getAssetsByCode } from "../../API/assets";
import BackButton from "../Common/BackButton/BackButton";
import BreadCrumb from "../Common/BreadCrumb/BreadCrumb";
import PageTitle from "../Common/PageTitle/PageTitle";
import ChangeLog from "../Common/ChangeLog/ChangeLog";
import Assetia from '../Common/Assetia/Assetia';

//import './DependenciesDetail.css';

const { Title, Text } = Typography;

const AssetsDetail = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [assetCode, setAssetCode] = useState(null);

  useEffect(() => {
    const fetchDependency = async () => {
      try {
        const data = await getAssetsByCode(code);
        setAssetCode(data);
      } catch (error) {
        message.error("No se encontró el activo.");
      }
    };

    fetchDependency();
  }, [code]);

  const breadCrumbUrl = [
    { label: "Activos", url: "/assets" },
    { label: assetCode ? `${assetCode.name}` : "Cargando..." },
  ];

  const goToBioFunctions = () => {
    navigate(-1);
  };

  return (
    <>
      <Row justify="space-between">
        <Col>
          <PageTitle title="Detalle de Activos" icon="assets" />
        </Col>
        <Col>
          <ChangeLog data={assetCode} logs={assetCode?.logs || []} />
        </Col>
      </Row>

      <Row justify="start" align="middle" gutter={16} style={{ marginBottom: 20 }}>
        <Col style={{ display: "flex", alignItems: "center" }}>
          <BackButton onConfirm={goToBioFunctions} />
          <BreadCrumb location={breadCrumbUrl} activeKey={code} />
        </Col>
      </Row>
    {
      !assetCode ? (
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
        <div style={{ height: 32 }} />
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Skeleton active paragraph={{ rows: 6 }} />
          </Col>
          <Col xs={24} md={12}>
            <Skeleton active paragraph={{ rows: 6 }} />
          </Col>
        </Row>
      </>
      ) : (
      <>
        <Row gutter={[16, 16]} justify="center">
        {/* Card de Información General */}
          <Col xs={24} md={24}>
            <Card hoverable className="detail-card">
              <div className="card-content">
                <div className="text-content">
                  <Title className="title-custom" level={4}>Activo</Title>
                
                  {assetCode ? (
                    <Descriptions bordered column={1} size="middle">
                      <Descriptions.Item label="Nombre">
                        <Text strong>{assetCode.name}</Text>
                      </Descriptions.Item>
                      <Descriptions.Item label="Descripción">
                        {assetCode.description || "No disponible"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Área">
                        {assetCode.area?.name || "No disponible"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Categoría">
                        {assetCode.category?.name || "No disponible"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Usuario">
                        {assetCode.user?.username || "No disponible"}
                      </Descriptions.Item>
                    </Descriptions>
                    ) : (
                      <Text type="secondary">Cargando detalles...</Text>
                    )}
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        <Row style={{ marginTop: 80 }}>
          <Assetia 
            pageTitle="detalle de activos" 
            pageDescription="ver en detalle la información de tu activo"
            tips={[
              "Consulta el detalle para comprender el impacto de cada activo en tu proceso.",
              "Revisa el historial para identificar patrones y posibles áreas de mejora.",
              "Verifica los recursos asociados para entender mejor el activo."
            ]}            
          />
        </Row>
      </>
      )
    }
    </>
  );
};

export default AssetsDetail;
